import React, { useState } from "react";
import { Button } from "@hopper/button";

import { FlexibleTestingTest } from "types/graphql";
import { ModeratorsPanel } from "./moderators_panel";

type OpenModeratorsButtonProps = {
  platformTest: FlexibleTestingTest;
};

export const OpenModeratorsButton = ({ platformTest }: OpenModeratorsButtonProps) => {
  const [isPanelOpen, setIsPanelOpen] = useState(false);

  return (
    <>
      <Button variant="secondary" className="m-xs" onClick={() => setIsPanelOpen(true)}>
        Moderators
      </Button>
      <ModeratorsPanel
        isPanelOpen={isPanelOpen}
        onPanelClose={() => setIsPanelOpen(false)}
        platformTest={platformTest}
      />
    </>
  );
};
